export default {
  "site.title": "KakobuyFinds",
  "site.tagline": "Największa baza wiedzy o Kakobuy Spreadsheet w Polsce",
  "nav.home": "Strona Główna",
  "nav.categories": "Kategorie",
  "nav.guide": "Przewodnik",
  "nav.safety": "Bezpieczeństwo",
  "nav.faq": "FAQ",
  "nav.article": "Artykuł",
  "nav.shopping_guide": "Poradnik Zakupowy",
  "nav.articles": "Artykuły",
  "hero.title": "Kakobuy Spreadsheet – Najszybszy sposób na znalezienie najlepszych produktów",
  "hero.subtitle": "Nie trać godzin na szukanie produktów. Nasz Kakobuy Spreadsheet pomaga znaleźć najlepsze produkty, sprawdzić popularne finds oraz rozpocząć zakupy szybciej i bezpieczniej.",
  "hero.cta_primary": "Otwórz Kakobuy Spreadsheet",
  "hero.cta_secondary": "Zobacz najnowsze Kakobuy Finds",
  "hero.cta_buy": "Buy It Now",
  "trust.updated": "Aktualizowane listy produktów",
  "trust.categories": "Kategorie sneakers & streetwear",
  "trust.guides": "Przewodniki dla początkujących",
  "trust.safety": "Porady bezpieczeństwa",
  "about.title": "Co to jest Kakobuy Spreadsheet?",
  "about.content": "Kakobuy Spreadsheet to uporządkowana lista produktów, która pomaga użytkownikom szybciej znaleźć interesujące przedmioty. Zamiast przeszukiwać setki stron, możesz korzystać z gotowych kategorii, popularnych produktów oraz rekomendowanych linków. Dzięki Kakobuy Spreadsheet możesz łatwiej porównywać produkty, sprawdzać informacje i podejmować lepsze decyzje zakupowe.",
  "why.title": "Dlaczego warto korzystać z Kakobuy Spreadsheet?",
  "why.time.title": "Oszczędność czasu",
  "why.time.desc": "Gotowe listy produktów zamiast wielogodzinnego szukania.",
  "why.organize.title": "Lepsza organizacja",
  "why.organize.desc": "Kategorie, produkty i informacje w jednym miejscu.",
  "why.safety.title": "Bezpieczniejsze decyzje",
  "why.safety.desc": "Poradniki pomagają unikać typowych błędów.",
  "compare.title": "Kakobuy Spreadsheet vs tradycyjne szukanie",
  "compare.col1": "Metoda",
  "compare.col2": "Czas",
  "compare.col3": "Wygoda",
  "compare.col4": "Ryzyko błędów",
  "compare.row1_col1": "Google Search",
  "compare.row1_col2": "Długi",
  "compare.row1_col3": "Niska",
  "compare.row1_col4": "Wysokie",
  "compare.row2_col1": "Social Media",
  "compare.row2_col2": "Średni",
  "compare.row2_col3": "Średnia",
  "compare.row2_col4": "Średnie",
  "compare.row3_col1": "Kakobuy Spreadsheet",
  "compare.row3_col2": "Krótki",
  "compare.row3_col3": "Wysoka",
  "compare.row3_col4": "Niższe",
  "how.title": "Jak działa Kakobuy Spreadsheet?",
  "how.step1": "Wybierz kategorię",
  "how.step2": "Znajdź produkt",
  "how.step3": "Sprawdź informacje",
  "how.step4": "Przejdź do głównego serwisu",
  "safety.title": "Czy Kakobuy Spreadsheet jest bezpieczny?",
  "safety.content": "Kakobuy Spreadsheet jest narzędziem informacyjnym, które pomaga użytkownikom znaleźć produkty.",
  "safety.tip1": "sprawdzaj źródło linków",
  "safety.tip2": "nie udostępniaj haseł",
  "safety.tip3": "analizuj informacje przed zakupem",
  "safety.tip4": "korzystaj tylko z zaufanych stron",
  "safety.table_header1": "Element",
  "safety.table_header2": "Dobra praktyka",
  "safety.row1_col1": "Hasło",
  "safety.row1_col2": "Nigdy nie udostępniaj",
  "safety.row2_col1": "Linki",
  "safety.row2_col2": "Sprawdzaj źródło",
  "safety.row3_col1": "Produkty",
  "safety.row3_col2": "Analizuj informacje",
  "safety.row4_col1": "Płatności",
  "safety.row4_col2": "Używaj bezpiecznych metod",
  "faq.title": "Najczęściej zadawane pytania",
  "faq.q1": "Czym jest Kakobuy Spreadsheet?",
  "faq.a1": "Kakobuy Spreadsheet to uporządkowana lista produktów, która pomaga użytkownikom szybciej znaleźć interesujące przedmioty. Zawiera gotowe kategorie, popularne produkty oraz rekomendowane linki, dzięki czemu oszczędzasz czas na przeszukiwaniu setek stron.",
  "faq.q2": "Czy Kakobuy Spreadsheet jest darmowy?",
  "faq.a2": "Tak, Kakobuy Spreadsheet jest dostępny jako narzędzie informacyjne. Możesz swobodnie korzystać z list produktów i kategorii, aby znaleźć interesujące Cię przedmioty.",
  "faq.q3": "Jak znaleźć najlepsze Kakobuy Finds?",
  "faq.a3": "Najlepsze Kakobuy Finds znajdziesz przeglądając nasze kategorie produktów. Każda kategoria zawiera starannie wybrane produkty, które cieszą się popularnością wśród użytkowników. Regularnie aktualizujemy nasze listy, aby zapewnić dostęp do najnowszych znalezisk.",
  "faq.q4": "Czy Kakobuy jest bezpieczny?",
  "faq.a4": "Kakobuy Spreadsheet jest narzędziem informacyjnym. Bezpieczeństwo zależy od praktyk użytkownika — zawsze sprawdzaj źródło linków, nie udostępniaj swoich haseł i korzystaj tylko z zaufanych stron. Nasze poradniki pomogą Ci unikać typowych błędów.",
  "faq.q5": "Jak korzystać z Kakobuy Spreadsheet?",
  "faq.a5": "Korzystanie jest proste: wybierz interesującą Cię kategorię, znajdź produkt, sprawdź dostępne informacje, a następnie przejdź do głównego serwisu, aby dokonać zakupu. Cały proces zajmuje zaledwie kilka minut.",
  "cta.title": "Gotowy na odkrycie najlepszych produktów?",
  "cta.subtitle": "Dołącz do tysięcy zadowolonych użytkowników Kakobuy Spreadsheet i zacznij znajdować najlepsze produkty już dziś.",
  "cta.button": "Otwórz Kakobuy Spreadsheet Teraz",
  "cta.buy_button": "Buy It Now",
  "footer.description": "KakobuyFinds to największa baza wiedzy o Kakobuy Spreadsheet w Polsce. Znajdź najlepsze produkty, poradniki i aktualne listy.",
  "footer.quick_links": "Szybkie Linki",
  "footer.categories": "Kategorie",
  "footer.articles": "Artykuły",
  "footer.copyright": "© 2026 KakobuyFinds.quest. Wszelkie prawa zastrzeżone.",
  "categories.title": "Kategorie Kakobuy Finds",
  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies/Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants/Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "Underwear/Underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",
  "article.title": "Kakobuy Spreadsheet – Kompletny Przewodnik dla Polskich Kupujących",
  "article.cta": "Wróć do strony głównej",
  "breadcrumb.home": "Strona Główna",
  "breadcrumb.article": "Przewodnik Kakobuy Spreadsheet",
  "seo.section_title": "Artykuły i Poradniki Kakobuy Spreadsheet",
  "seo.section_subtitle": "Poznaj nasze oryginalne artykuły pełne praktycznych porad, wskazówek i strategii zakupowych",
  "seo.read_more": "Czytaj więcej",
  "seo.min_read": "min czytania",
  "home.articles_title": "Najnowsze Artykuły SEO",
  "home.articles_subtitle": "Oryginalne poradniki i przewodniki – wszystko, co musisz wiedzieć o Kakobuy Spreadsheet",
}